import { Injectable } from '@angular/core';

import { ClientConfigProductName, ContentService } from '@frontend/vanilla/core';
import { Subject } from 'rxjs';

import { DashboardContent, RewardsHubSegments, RewardsHubSegmentsContentPath } from './model';

@Injectable({
    providedIn: 'root',
})
export class ToggleNavigationService {
    isPromoActive: boolean = true;
    promoOffersRoute: string = '';
    rewardsHubRoute: string = '';
    rewardsHubSegments: RewardsHubSegments;
    isContentLoaded: Subject<boolean> = new Subject<boolean>();

    constructor(private contentService: ContentService) {}

    loadDashboardContent(): void {
        this.contentService.getJsonFiltered<DashboardContent>(RewardsHubSegmentsContentPath, ClientConfigProductName.PROMO).subscribe({
            next: (dashboardContent: DashboardContent) => {
                this.rewardsHubSegments = dashboardContent?.messages || {};
                this.promoOffersRoute = this.rewardsHubSegments?.promoHubUrl || '';
                this.rewardsHubRoute = this.rewardsHubSegments?.rewardsHubUrl || '';
                this.isContentLoaded.next(true);
            },
            error: () => {
                this.isContentLoaded.next(false);
            },
        });
    }

    get isTooltipClosed(): boolean {
        if (localStorage.getItem('isTooltipClosed') === null) {
            localStorage.setItem('isTooltipClosed', 'false');
        }
        return localStorage.getItem('isTooltipClosed') === 'true';
    }

    set isTooltipClosed(value: boolean) {
        localStorage.setItem('isTooltipClosed', String(value));
    }

    get storedUserId(): string | null {
        return localStorage.getItem('loggedInUserId');
    }

    set storedUserId(userId: string | null) {
        if (userId) {
            localStorage.setItem('loggedInUserId', userId);
        } else {
            localStorage.removeItem('loggedInUserId');
        }
    }
}
